import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { FirebaseUserModel } from '../core/user.model';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { DialogOverviewExampleDialogComponent } from '../home/home.component.dialog';

@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.scss']
})
export class MyTicketsComponent implements OnInit {
  user: FirebaseUserModel = new FirebaseUserModel();
  public items: Observable<any>;
  public orderedItems: any;
  public orderedItemsByLikes: any;

  constructor(
      private route: ActivatedRoute,
      private location: Location,
      private fb: FormBuilder,
      private db: AngularFirestore,
      public dialog: MatDialog
  ) {

  }

  ngOnInit() {
    this.route.data.subscribe(routeData => {
      const data = routeData.data;
      if (data) {
        this.user = data;
        this.items = this.db.collection('tickets').valueChanges();
      }
    });
    this.getItems();
  }

  getItems = () => {
    this.items.subscribe(item => this.orderItems(item));
    this.items.subscribe(item => this.orderItemsByLikes(item));
  }

  orderItems = (items: any) => {
    // items.sort((a, b) => (a.color > b.color) ? 1 : -1);
    this.orderedItems = items.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
  }
  orderItemsByLikes = (items: any) => {
    // items.sort((a, b) => (a.color > b.color) ? 1 : -1);
    this.orderedItemsByLikes = items.sort((a, b) => (a.likers.length < b.likers.length) ? 1 : -1);
  }

  openDialog = (item: any) => {
    console.log('uid', item);
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '500px',
      data: {
        course: item.course,
        subject: item.subject,
        description: item.description,
        category: item.category,
        priority: item.priority,
        status: item.status,
        createdBy: item.createdBy,
        responsible: item.responsible,
        respmail: item.respmail,
        user: this.user.email,
        uid: item.uid,
        comment: item.comment,
        likes: item.likers ? item.likers.length : 0,
        likers: item.likers ? item.likers : []
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }
}
